import React from 'react';
import { Music, Users, Star, Award } from 'lucide-react';
import { bandInfo } from '../data/mock';

const About = () => {
  const stats = [
    { icon: Music, value: '500+', label: 'Nastupa' },
    { icon: Users, value: '10+', label: 'Godina' },
    { icon: Star, value: '100%', label: 'Zadovoljnih' },
    { icon: Award, value: '5', label: 'Članova' }
  ];

  // Grupna slika benda za O nama sekciju
  const aboutImage = "https://customer-assets.emergentagent.com/job_d6cd3282-14a9-4414-b3c7-581f3467546a/artifacts/f5xc8v8a_kocka.png";

  return (
    <section id="about" className="py-32 bg-[#000000] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold-400/20 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-gold-400/20 to-transparent" />
      
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="text-gold-400 text-xs font-medium tracking-[0.3em] uppercase mb-6 block">
            Upoznajte nas
          </span>
          <h2 className="text-5xl sm:text-6xl lg:text-7xl font-light text-gold-400 mb-6">
            O <span className="text-gold-gradient">bendu</span>
          </h2>
          <div className="w-16 h-[1px] bg-gold-400 mx-auto" />
        </div>

        <div className="grid lg:grid-cols-2 gap-20 items-center">
          {/* Image */}
          <div className="relative group">
            {/* Frame */}
            <div className="absolute -inset-4 border border-gold-400/20" />
            <div className="absolute -inset-8 border border-gold-400/10" />
            
            <div className="relative overflow-hidden">
              <img
                src={aboutImage}
                alt="Bend Kocka Šećera"
                className="w-full h-auto object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#000000]/60 via-transparent to-transparent" />
            </div>
            
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-[#000000] border border-gold-400/30 p-6">
              <div className="text-4xl font-light text-gold-400">10+</div>
              <div className="text-xs tracking-[0.2em] uppercase text-white/60">Godina iskustva</div>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-8">
            <p className="text-white/80 text-lg leading-relaxed font-light">
              {bandInfo.description}
            </p>
            <p className="text-white/60 leading-relaxed font-light">
              Naš repertoar obuhvata sve muzičke žanrove - od narodne i starogradske muzike, 
              preko pop i rock hitova, do najnovijih svetskih i domaćih pesama. Prilagođavamo 
              se vašim željama i garantujemo da će svaki gost naći pesmu za sebe.
            </p>
            <p className="text-white/60 leading-relaxed font-light">
              Sa profesionalnom opremom i dugogodišnjim iskustvom, bend Kocka Šećera je 
              sinonim za kvalitetnu muziku i nezaboravnu zabavu na svakoj proslavi.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-4 gap-4 pt-8 border-t border-white/10">
              {stats.map((stat, index) => (
                <div key={index} className="text-center">
                  <stat.icon className="w-5 h-5 text-gold-400 mx-auto mb-3" />
                  <div className="text-2xl font-light text-white">{stat.value}</div>
                  <div className="text-xs tracking-wider uppercase text-white/40">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
